import { RouteObject } from "react-router-dom";
import FeatureLogin from "./Feature_Login";
import { R_LoginRoutes } from "../../utils/Routes";
import { lazy } from "react";
import SuspenseWrapper from "../../components/CustomLazyLoading/CustomLazyLoading";

const PolicyAndConditionsPage = lazy(
  () =>
    import("../Feature_GeneralAppElements/PolicyAndConditionsPage/PolicyAndConditionsPage"),
);

const LoginRoutes: RouteObject[] = [
  {
    path: R_LoginRoutes.login,
    element: <FeatureLogin />,
  },
  {
    path: R_LoginRoutes.policyAndConditions,
    element: <SuspenseWrapper LazyLoadingComponent={PolicyAndConditionsPage} />,
  },
];
export default LoginRoutes;
